export default __webpack_public_path__ + "static/media/1.3961d6d4.png";